import React, { Component } from 'react';
import AssignmentEventsScreen from './AssignmentEventsScreen'


function AssignmentEventMainScreen () {
  
    return (
      <div className="App">
          
       
      <AssignmentEventsScreen />
       
      
      </div>
    );
  
}

export default AssignmentEventMainScreen;